import { createFileRoute } from "@tanstack/react-router";
import { fotoCityRoute } from "@/lib/seo/fotoCityRoute";

export const Route = createFileRoute("/foto/goteborg")(fotoCityRoute("goteborg"));
